import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import {useSelector} from "react-redux";
import React from "react";
import swal from "sweetalert";
import noImage from "../../assets/media/svg/no-image.svg";
import "../../assets/css/pages/product.css";
import _ from "lodash";
import {useForm} from "react-hook-form";
import ProductFilters from "./ProductFilters";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import Button from "../../Components/Buttons/Button";
import {downloadBlob} from "../../Components/Helpers/Utils";
import dayjs from "dayjs";
import {TIMESTAMP_FORMAT} from "../../Constants/Constants";

const frontUrl = process.env.REACT_APP_CLIENT_SIDE_URL;

const ProductsPage = () => {
  const actionBtn = (status, row) => {
    if (status == 1) {

      return (`<button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-success me-2 mb-4 mt-1  approve"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fa fa-check"></i> Approve
                            </button>
                            <button 
                            class="btn btn-danger me-2 mb-4 mt-1 reject"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fa fa-ban"></i> Reject
                            </button>
                            <button
                            class="btn btn-danger me-2 mb-4 mt-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>`)
    } else if (status == 2) {
      return (`
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                        ${row?.published ?
        `<button
                            class="btn btn-danger me-2 mb-4 mt-1 unpublish"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-times-circle"></i> Unpublish
                            </button>` :
        `<button
                            class="btn btn-success me-2 mb-4 mt-1 publish"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-arrow-alt-circle-up"></i> Publish
                            </button>`}
                            <button 
                            class="btn btn-danger me-2 mb-4 mt-1 reject"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fa fa-ban"></i> Reject
                            </button>
                            <button
                            class="btn btn-danger me-2 mb-4 mt-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>              
                    `);
    } else if (status == 3) {
      return (`
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button
                            class="btn btn-success me-2 mb-4 mt-1 approve"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fa fa-check" aria-hidden="true"></i> Approve
                            </button>
                            <button
                            class="btn btn-light me-2 mb-4 mt-1 pending fs-8"
                            row-id="${row.id}" row-name="${row.name}">
                            <i class="fas far fa-question-circle" aria-hidden="true"></i> Make Pending
                            </button>
                            <button
                            class="btn btn-danger me-2 mb-4 mt-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `);
    } else if (!status) {
      return (`
                  <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                            <button
                            class="btn btn-danger me-2 mb-4 mt-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                            <button
                            class="btn btn-primary me-2 mb-4 mt-1 discount-history"
                            row-id="${row.id}">
                                <i class="fas fa-history"></i> Discount history
                            </button>
                        <div>
                    </div>
                    `)
    }
  }

  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;
  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const {status} = useParams();

  const {register, handleSubmit, control, reset, getValues, watch} = useForm({
    defaultValues: {
      bundle: null,
      sale: null,
      category_id: null,
      max_price: null,
      min_price: null,
      shop_id: null,
      published: null,
      start_date: null,
      end_date: null,
    }
  });
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [showOnlyUnpublished, setShowOnlyUnpublished] = useState(0);
  const [filters, setFilters] = useState({
    forceSearch: false,
  });


  useEffect(() => {
    setBulkArray([]);
  }, [status]);


  const handleFiltersSubmit = values => {
    setFilters({...values, only_unpublished: showOnlyUnpublished, forceSearch: !filters.forceSearch});
  }

  const handleFilterByPublish = value => {
    setShowOnlyUnpublished(value ? 1 : 0);
    setFilters({...filters, only_unpublished: value ? 1 : 0, forceSearch: !filters.forceSearch});
  }

  useEffect(() => {
    axios.get('/products/filters').then(res => {
      setData(res.data.data);
    });
  }, []);

  useEffect(() => {
    $("#products thead .filters").remove();
    $('#products thead tr')
      .clone(true)
      .addClass('filters display-none')
      .appendTo('#products thead');

    let table = $('#products').DataTable({
      "destroy": true,
      "ajax": {
        url: process.env.REACT_APP_API_URL + "products",
        method: 'GET',
        data: {...filters, status: status},
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      initComplete: function () {
        var api = this.api();

        // For each column
        api
          .columns()
          .eq(0)
          .each(function (colIdx) {
            // Set the header cell to contain the input element
            var cell = $('.filters th').eq(
              $(api.column(colIdx).header()).index()
            );
            var title = $(cell).text();
            $(cell).html('<input type="text" placeholder="' + title + '" />');

            // On every keypress in this input
            $(
              'input',
              $('.filters th').eq($(api.column(colIdx).header()).index())
            )
              .off('keyup change')
              .on('keyup change', function (e) {
                e.stopPropagation();

                // Get the search value
                $(this).attr('title', $(this).val());
                var regexr = '({search})'; //$(this).parents('th').find('select').val();

                var cursorPosition = this.selectionStart;
                // Search the column for that value
                api
                  .column(colIdx)
                  .search(
                    this.value != ''
                      ? regexr.replace('{search}', '(((' + this.value + ')))')
                      : '',
                    this.value != '',
                    this.value == ''
                  )
                  .draw();

                $(this)
                  .focus()[0]
                  .setSelectionRange(cursorPosition, cursorPosition);
              });
          });
      },
      "columns": [
        {
          data: 'checkbox',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"></span>
                    </label>`;
          },
        },
        {data: 'seller', name: 'seller', orderable: false},
        {data: 'id', name: 'id', 'width': '10%'},
        {
          data: 'image',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            let img = noImage;
            if (row?.thumbnail != null) {
              img = row?.thumbnail
            }
            let productUrl = frontUrl + 'product/' + (row.slug || row.name.replace(/(\W+|\s+)/g, '-')) + '/' + row.id;
            return `<a href="${productUrl}" target="_blank">
                        <div class="image${img == noImage ? ' no-image' : ''}">
                            <img class="w-100${img == noImage ? ' opacity-25' : ''}" row-id="${row.id}" src="${img}" />
                        </div>
                    </a>`;
          },
        },
        {
          data: 'name', name: 'name',
          render: function (data, type, row) {
            return `<button type="button" class="btn btn-link ls-1 text-hover-primary fs-6 fw-normal ellipsis edit" row-id="${row.id}">
                                   ${row.name}
                                </button>`;
          }
        },
        {data: 'sku', name: 'sku'},
        {
          data: 'total_quantity',
          name: 'total_quantity',
          searchable: false,
          render: function (data, type, row) {
            return `<div class="d-flex align-items-center flex-row">
                                    <div class="ms-5">
                                        <a
                                           class="text-hover-primary fs-5"
                                           data-kt-ecommerce-product-filter="product_name"
                                           >${row?.total_quantity || 0}
                                        </a>
                                    </div>
                                </div>`
          }
        },
        {data: 'price', name: 'price'},
        {
          data: 'profit_margin', name: 'profit_margin',
          render: function (data, type, row) {
            return `<div style="text-align:center; font-weight: bold; color: ${row.low_margin ? 'red' : 'green'}">${row.profit_margin || ''}</div>`;
          }
        },
        {data: 'product_status', name: 'product_status', orderable: false},
        {data: 'last_approved_at', name: 'last_approved_at', orderable: true, searchable: false},
        {
          data: 'published', name: 'published', orderable: true, searchable: false,
          render: function (data, type, row) {
            return `<div class="p-3 fs-8 text-center text-white rounded ${row?.published ? "bg-success" : "bg-danger"}"
                         row-id="${row?.id} row-name="${row?.name}">
                               ${row?.published ? "Published" : "Unpublished"}
                            </div>`;
          }
        },
        {
          data: 'created_at',
          name: 'created_at',
          searchable: false,
          render: function (data, type, row) {
            return dayjs(row.created_at).format(TIMESTAMP_FORMAT)
          }
        },
        {
          data: 'updated_at',
          name: 'updated_at',
          searchable: false,
          render: function (data, type, row) {
            return dayjs(row.updated_at).format(TIMESTAMP_FORMAT)
          }
        },
        {
          data: 'actions',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return actionBtn(status, row);
          }
        },
      ],
      "order": [[
        data?.statuses?.find((item) => item.id === parseInt(status))?.name === 'Approved' ? 10 : 0,
        "desc"
      ]],
      columnDefs: [
        {
          "defaultContent": "",
          "targets": "_all"
        },
      ],
    });

    $('#search_input').keyup(function () {
      table.search($(this).val()).draw();
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      $(this).next(".row-actions").fadeToggle(100).toggleClass('hidden-actions');
    });

    table.on('click', 'button.approve', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      const status = 'Approved';
      updateStatus(id, name, status, table);
    });

    table.on('click', 'button.pending', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      const status = 'Pending';
      updateStatus(id, name, status, table);
    });

    table.on('click', 'button.reject', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      const status = 'Rejected';
      updateStatus(id, name, status, table);
    });

    table.on('click', 'button.publish', function () {
      const id = ($(this).attr("row-id"));
      updatePublishStatus(id, true, table);
    });

    table.on('click', 'button.unpublish', function () {
      const id = ($(this).attr("row-id"));
      updatePublishStatus(id, false, table);
    });

    const updateStatus = (id, name, status, table) => {
      swal({
        title: "Are you sure?",
        text: `You want to make ${status} this product?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "",
          closeModal: true
        }
      }).then((result) => {
        if (result == true) {
          axios.post(`/products/${id}/status/update`,
            {'status': status})
            .then((res) => {
              swal(`Product has been ${status}!`, {
                icon: "success",
              });
              table.draw(false);
              return true;
            }).catch(errors => {
            console.log(errors)
          });
        }
      });
    }


    const updatePublishStatus = (id, status, table) => {
      swal({
        title: "Are you sure?",
        text: `You want to ${status ? "publish" : "unpublish"} this product?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "",
          closeModal: true
        }
      }).then((result) => {
        if (result == true) {
          axios.post(`/products/${id}/publish`,
            {published: status})
            .then((res) => {
              swal(`Product has been ${status ? "published" : "unpublished"}!`, {
                icon: "success",
              });
              table.draw(false);
              return true;
            }).catch(errors => {
            console.log(errors)
          });
        }
      });
    }

    table.on('click', 'button.edit', function () {
      const id = ($(this).attr("row-id"));
      navigate(`/products/${id}/edit`);
    });

    table.on('click', 'button.delete', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      swal({
        title: "Are you sure?",
        text: `You want to delete ${name}?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "",
          closeModal: true
        }
      }).then((result) => {
        if (result == true) {
          axios.delete(`/products/${id}`)
            .then((res) => {
              if(res) {
                swal(`Product has been deleted!`, {
                  icon: "success",
                });
                table.draw(false);
                return true;
              }
            }).catch(errors => {
            console.log(errors)
          });
        }
      });
    });

    table.on('click', 'button.discount-history', function () {
      const id = ($(this).attr("row-id"));
      navigate(`/products/${id}/discount-history`);
    });

    $("<span class='table-filter-icon' title='Filter'><i class='fa fa-filter fs-4 br-1000'></i>Filter</span>")
      .insertAfter(".dataTables_length label");

    $(".table-filter-icon").click(function () {
      $(".toggle-filter").slideToggle(200)

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

    $('.toggle-filter').each(function () {
      if ($(this).css('display') == 'block') {
        $(".table-filter-icon i")
          .removeClass("fa fa-filter")
          .addClass("far fa-times-circle")
      }
    });

    table.on('click', '.form-label-checkbox .checkbox', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });

    $("table.dataTable thead tr:first-child th:nth-child(1)")
      .html(`<label class="form-label-checkbox form-label-checkbox-mark-all  fs-6 fw-bolder text-dark pt-0">
           <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
           <span class="checkmark"><span></span></span>
           </label>`);


  }, [status, filters.forceSearch]);


  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  //Bulk Action Start()

  const bulkDeleteProducts = () => {
    swal({
      title: "Are you sure?",
      text: `You want to delete marked products?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      console.log(result);
      if (result == true) {
        axios.post('products/bulk-destroy', {
          products: bulkArray,
        })
          .then(function (res) {
            if (res.status == 200) {
              swal(`Products has been deleted successfully!`, {
                icon: "success",
              });

              setFilters({...filters, forceSearch: !filters.forceSearch})
              resetMarked();
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data.errors);
            }
          });
      }
    });
  }

  const bulkUpdateStatus = (productStatus) => {
    swal({
      title: "Are you sure?",
      text: `You want to make ${productStatus} marked products?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.post("products/bulk-status",
          {products: bulkArray, status: productStatus})
          .then((res) => {
            if (res.status == 200) {
              swal(`Products has been ${productStatus}!`, {
                icon: "success",
              });

              setFilters({...filters, forceSearch: !filters.forceSearch});
              resetMarked();
              return true;
            }
          }).catch(errors => {
          console.log(errors)
        });
      }
    });
  }

  const bulkUpdatePublish = (publishStatus) => {
    swal({
      title: "Are you sure?",
      text: `You want to ${publishStatus ? "publish" : "unpublish"} marked products?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.post("products/bulk-publish",
          {products: bulkArray, publish: publishStatus})
          .then((res) => {
            if (res.status == 200) {
              swal(`Products has been ${publishStatus ? "published" : "unpublished"}!`, {
                icon: "success",
              });

              setFilters({...filters, forceSearch: !filters.forceSearch});
              resetMarked();
              return true;
            }
          }).catch(errors => {
          console.log(errors)
        });
      }
    });
  }
  //Bulk Action End()

  const exportProducts = () => {
    axios.get('exports/products', {
      params: {...getValues(), status: status},
      responseType: 'blob',
    }).then(res => {
      downloadBlob(res.data, 'products.xlsx');
    });
  }

  const resetFilter = () => {
    reset();
    handleFiltersSubmit();
  }

  return (
    <>
      <div>
        <div className="mb-5">
          <div className="toggle-filter ">
            <form onSubmit={handleSubmit(handleFiltersSubmit)} className="row">
              <ProductFilters {...{register, errors, control, data, watch}} />
              <div>
                <SubmitButton
                  title="Filter"
                  beforeTitle={<><i className="fas fa-sync-alt fs-5 mr-2"></i></>}
                />
                <button
                  type="button"
                  className="btn btn-lg btn-primary clear-filter mb-5 ml-2 px-5"
                  title="Clear Filter"
                  onClick={resetFilter}
                >
                  <span className="indicator-label clear-filter-icon">
                    <i className="fa fa-times-circle fs-3 display-contents"></i>
                  </span>
                  <span className="clear-filter-text">Clear</span>
                </button>
                <button
                  type="button"
                  className='btn btn-lg btn-primary mb-5 ml-2'
                  onClick={exportProducts}
                >
                  <span className="indicator-label">
                    <i className="fa fa-download"></i>
                    Export
                  </span>
                </button>
              </div>
            </form>

          </div>
          <div className="text-right">
            <div
              className={`marked-actions border-end mr-3 pr-3 d-inline-block${buttonIsDisabled ? " d-none" : ""}`}>
              {
                status == 2 &&
                <>
                  <span>
                    <button
                      type="button"
                      className="btn btn-success mr-3"
                      onClick={() => bulkUpdatePublish(true)}
                      disabled={buttonIsDisabled}
                    >
                      <i className="far fa-arrow-alt-circle-up fs-5 mr-2"></i> Publish
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger mr-3"
                      onClick={() => bulkUpdatePublish(false)}
                      disabled={buttonIsDisabled}
                    >
                      <i className="far fa-times-circle fs-5 mr-2"></i> Unpublish
                    </button>
                  </span>

                </>
              }
              {
                (status == 1 || status == 3) &&
                <>
                  <button
                    type="button"
                    className="btn btn-success mr-3"
                    onClick={() => bulkUpdateStatus("Approved")}
                    disabled={buttonIsDisabled}
                  >
                    <i className="fa fa-check fs-5 mr-2"></i> Approve
                  </button>
                </>
              }
              {
                (status == 3) &&
                <>
                  <button
                    type="button"
                    className="btn btn-light border mr-3"
                    onClick={() => bulkUpdateStatus("Pending")}
                    disabled={buttonIsDisabled}
                  >
                    <i class="fas far fa-question-circle fs-5 mr-2"></i> Make Pending
                  </button>
                </>
              }
              {
                (status == 1 || status == 2) &&
                <>
                  <button
                    type="button"
                    className="btn btn-danger mr-3"
                    onClick={() => bulkUpdateStatus("Rejected")}
                    disabled={buttonIsDisabled}
                  >
                    <i className="fa fa-ban fs-5 mr-2"></i> Reject
                  </button>
                </>
              }
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => bulkDeleteProducts()}
                disabled={buttonIsDisabled}
              >
                <i className="far fa-trash-alt fs-5 mr-2"></i> Delete
              </button>
            </div>
            <div className="d-inline-block mr-3">
              <input
                className="form-check-input cursor-pointer"
                type="checkbox" name="only_unpublished"
                onChange={(e) => handleFilterByPublish(e.target.checked)}
              />
              <label className="form-check-label ml-3" htmlFor="flexCheckChecked">
                Only unpublished
              </label>
            </div>
            <div className="d-inline-block">
              <Link to="/products/create" className="btn btn-primary">
                <i className="fas fa-plus-circle fs-5 mr-2"></i>
                Add Product
              </Link>
            </div>
          </div>
        </div>

        <table className="table align-middle table-row-dashed fs-6 gy-5" id="products">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th className="pl-0"></th>
            <th className="text-start min-w-100px pl-2">Seller</th>
            <th className="text-start min-w-50px pl-2">ID</th>
            <th className="text-start min-w-100px">Image</th>
            <th className="text-start min-w-100px">Name</th>
            <th className="text-start min-w-70px">Sku</th>
            <th className="text-start min-w-100px">Quantity</th>
            <th className="text-start min-w-100px">Price</th>
            <th className="text-start min-w-100px">Margin info</th>
            <th className="text-start min-w-100px">Status</th>
            <th className="text-start min-w-100px">Last approved</th>
            <th className="text-start min-w-100px">Publish</th>
            <th className="text-start min-w-100px">Created At</th>
            <th className="text-start min-w-100px">Updated At</th>
            <th className="text-start min-w-100px">Actions</th>
          </tr>
          </thead>
          <tbody className="text-gray-600">

          </tbody>
        </table>
      </div>
    </>
  )
}

export default ProductsPage;